module.exports = {"DATE_SELECT_DAY":"Day","DATE_SELECT_MONTH":"Month","DATE_SELECT_YEAR":"Year"}